import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { CatalogoParentescoSustitutoDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class CatalogoParentescoSustitutoService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getCatalogoParentescoSustitutoService(): Observable<BodyListResponse<CatalogoParentescoSustitutoDTO>> {
    return this.http.get<BodyListResponse<CatalogoParentescoSustitutoDTO>>(API_URL + '/api/v1/catalogoParentescoSustituto/todos');
  }

  guardarCatalogoParentescoSustitutoService(catalogoParentescoSustitutoDTO: CatalogoParentescoSustitutoDTO): Observable<CatalogoParentescoSustitutoDTO> {
    return this.http.post<CatalogoParentescoSustitutoDTO>(API_URL + '/api/v1/catalogoParentescoSustituto', catalogoParentescoSustitutoDTO);
  }

  getCatalogoParentescoSustitutoPorCodigoCatalogoParentescoSustitutoService(codigoCatalogoParentescoSustituto: string): Observable<BodyResponse<CatalogoParentescoSustitutoDTO>> {
    return this.http.get<BodyResponse<CatalogoParentescoSustitutoDTO>>(API_URL + '/api/v1/catalogoParentescoSustituto/' + codigoCatalogoParentescoSustituto);
  }
}
